import moment from 'moment';

export const TradeLicenseDateRule = (item, onValueChanged , value , values , itemList ) => {
  if (item.field.id === 'trade_license_issue_date'){
    const tradeLicenseExpiryDateIndex = itemList.indexOf(
      itemList.find((f) => f.field.id.toLowerCase() === 'trade_license_expiry_date')
    );
    if (tradeLicenseExpiryDateIndex !== -1)
      itemList[tradeLicenseExpiryDateIndex].data.minDate = moment(value).add(1, 'days');
    onValueChanged(null, 0, 'trade_license_expiry_date');

   }

};


